export default __webpack_public_path__ + "static/media/gradient-logo-mark.f0526ade.svg";